import { render, staticRenderFns } from "./add-affiliation.vue?vue&type=template&id=6681a172&scoped=true&"
import script from "./add-affiliation.vue?vue&type=script&lang=tsx&"
export * from "./add-affiliation.vue?vue&type=script&lang=tsx&"
import style0 from "./add-affiliation.vue?vue&type=style&index=0&id=6681a172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681a172",
  null
  
)

export default component.exports